// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const t = require('app/scripts/views/internal/teacup-with-helpers')(
  'plugin_alert',
);

module.exports = t.renderable(({ icon, message, name }) =>
  t.div('.plugin-alert', function () {
    t.img('.plugin-alert-icon', { src: icon });
    return t.div('.plugin-alert-content', function () {
      t.div('.plugin-alert-header', function () {
        t.span('.plugin-alert-name', name);
        return t.a('.alert-dismiss.js-dismiss-alert.icon-sm.icon-close', {
          href: '#',
        });
      });
      return t.span('.plugin-alert-msg', message);
    });
  }),
);
